export default __webpack_public_path__ + "static/media/image_error_graphic_illustration.6c962e60.png";